import template from './contract_type.html';
import tr from '../../lib/default-translator.js';

class AdminContractTypeViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_contract_type_help()
	{
		Grape.dialog.open('ContractsHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminContractTypePage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminContractTypeViewModel(this);
		document.title = tr('Manage Contract Types');
		window.current_page_title(tr('Add/Edit Contract Types'));
	}
}

export default {
	route: '[/]admin/contract_type',
	page_class: AdminContractTypePage,
	template: template,
	template_filename: 'translation/contract_type'
};
